import React from 'react'
import ErrorManager from './components/ErrorManager'
import EveServerManager from './components/EveServerManager'
import PlayableManager from './components/PlayableManager'
import ProcessManager from './components/ProcessManager'
import ProfileManager from './components/ProfileManager'
import ProgressManager from './components/ProgressManager'
import SettingManager from './components/SettingManager'
import TokenManager from './components/TokenManager'
import VersionManager from './components/VersionManager'
import SsoCodeManager from './components/SsoCodeManager'

const Backend = () => (
    <div>
        <ErrorManager />
        <EveServerManager />
        <PlayableManager />
        <ProcessManager />
        <ProfileManager />
        <ProgressManager />
        <SettingManager />
        <TokenManager />
        <VersionManager />
        <SsoCodeManager />
    </div>
)

export default Backend



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/index.js